import DropdownUser from "./DropdownUser";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../src/components/Button/Button";
import DateTimeDisplay from "../../../utils/DatePicker";
import SideDrawer from "../Drawer/SideDrawer";
import { Disclosure, DisclosureButton } from "@headlessui/react";

import { MenuOutlined } from "@ant-design/icons";
import { handleSearching } from "../../../store/general";

interface HeaderProps {
  // pagTitle: string;
  logo?: string;
}
const handleToggleBodyClass = () => {
  document.body.classList.toggle("sidebarOpen");
};
const Header: React.FC<HeaderProps> = ({ logo }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isOrganizationModalOpen, setIsOrganizationModalOpen] =
    useState<boolean>(false);
  const [dataEntryModelOpen, setDataEntryModelOpen] = useState<boolean>(false);
  const [seachItem, setSearchItem] = useState(null);
  const user = useSelector((state: any) => state?.Auth);
  const userData = user?.user?.data || user?.user?.user;

  const handleIsUserModelOpen: any = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleIsOrganizationModelOpen: any = () => {
    setIsOrganizationModalOpen(!isOrganizationModalOpen);
  };

  const handleAssignElementsModel: any = () => {
    if (userData?.roleId === 2) {
      navigate("/leader/assign-element");
    } else {
      navigate("/controller/assign-element");
    }
  };
  const handleIsDataEntryModelOpen: any = () => {
    setDataEntryModelOpen(!dataEntryModelOpen);
  };

  const handleSearchInputChange = (event) => {
    setSearchItem(event.target.value);
  };

  const handleSearchButton = () => {
    dispatch(handleSearching(seachItem));
    console.log(seachItem, ">");
  };

  return (
    <>
      <Disclosure>
        <header className="mainHeader p-[20px] ">
          <div className="mobilenavigation">
            <button
              className="hamburger hamburger--elastic toggleicon"
              onClick={handleToggleBodyClass}
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                x="0"
                y="0"
                viewBox="0 0 24 24"
              >
                <g>
                  <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z"
                    clipRule="evenodd"
                    opacity="1"
                    data-original="#fff"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          <div className="flex w-full justify-between items-center">
            <div>
              <DateTimeDisplay />
            </div>

            <div className="flex items-center gap-4 flex-1 justify-end">
              <div className="relative w-auto tab:w-[280px]">
                {/* <input
                  className="input-main-col header-input-col focus:bg-transparent rounded-[5px] mb-[0px] py-[4px] md:py-[8px] px-[10px] 2xl:py-[12px] md:pl-[60px] border-1 border-transparent focus:border-white w-full bg-[#141F2A] placeholder-[#fff] placeholder-[12px] text-white"
                  placeholder="Start Searching Here..."
                  onChange={(event) => handleSearchInputChange(event)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearchButton();
                    }
                  }}
                /> */}
                {/* <span className="hide-show-col absolute top-[8px]  md:top-[12px] 2xl:top-[14px] left-[10px] md:left-5 text-[#48bb89] text-sm cursor-pointer">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={handleSearchButton}
                  >
                    <g clipPath="url(#clip0_15_9425)">
                      <path
                        d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.867 18 18 14.867 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18ZM19.485 18.071L22.314 20.899L20.899 22.314L18.071 19.485L19.485 18.071Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15_9425">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span> */}
              </div>
              <div className="relative flex h-16 items-center justify-between">
                <div className="flex items-center gap-[10px] md:hidden">
                  {/* Mobile menu button*/}
                  <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 ">
                    <MenuOutlined
                      aria-hidden="true"
                      className="block size-6 group-data-open:hidden"
                    />
                    {/* <XOutlined
                      aria-hidden="true"
                      className="hidden size-6 group-data-open:block"
                    /> */}
                  </DisclosureButton>
                </div>
                {userData?.roleId === 1 ? (
                  <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                    <div className="hidden md:block">
                      <div className="flex text-white space-x-4 items-center">
                        <Button
                          buttonText="Create User"
                          padding="p-[12px] 2xl:p-[15px]"
                          text="text-[12px]"
                          handleIsModelOpen={handleIsUserModelOpen}
                        />
                        <Button
                          buttonText="Create Organization"
                          padding="p-[12px] 2xl:p-[15px]"
                          text="text-[12px]"
                          handleIsModelOpen={handleIsOrganizationModelOpen}
                        />
                        <div className="inline-flex items-center justify-center p-2 bg-primary max-h-[40px] rounded-full secondmenu">
                          <DropdownUser
                            userData={userData}
                            svgOptions="settings"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : userData?.roleId === 2 || userData?.roleId === 3 ? (
                  <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                    <div className="hidden md:block">
                      <div className="flex text-white space-x-4 items-center">
                        <Button
                          buttonText="Assign Element"
                          padding="p-[12px] 2xl:p-[15px]"
                          text="text-[12px]"
                          handleIsModelOpen={handleAssignElementsModel}
                        />
                        <Button
                          buttonText="Create Data Entry"
                          padding="p-[12px] 2xl:p-[15px]"
                          text="text-[12px]"
                          handleIsModelOpen={handleIsDataEntryModelOpen}
                        />
                        <div className="inline-flex items-center justify-center p-2 bg-primary max-h-[40px] rounded-full secondmenu">
                          <DropdownUser
                            userData={userData}
                            svgOptions="settings"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                    <div className="hidden md:block">
                      <div className="flex text-white space-x-4 items-center">
                        <Button
                          buttonText="Create Data Entry"
                          padding="p-[12px] 2xl:p-[15px]"
                          text="text-[12px]"
                          handleIsModelOpen={handleIsDataEntryModelOpen}
                        />
                        <div className="inline-flex items-center justify-center p-2 bg-primary max-h-[40px] rounded-full secondmenu">
                          <DropdownUser
                            userData={userData}
                            svgOptions="settings"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full secondmenu">
                <DropdownUser userData={userData} svgOptions="bell" />
              </div>
            </div>
          </div>
        </header>
      </Disclosure>
      <SideDrawer
        open={isModalOpen}
        onClose={handleIsUserModelOpen}
        type={"user"}
      />
      <SideDrawer
        open={isOrganizationModalOpen}
        onClose={handleIsOrganizationModelOpen}
        type={"organization"}
      />
      <SideDrawer
        open={dataEntryModelOpen}
        onClose={handleIsDataEntryModelOpen}
        type={"dataEntry"}
      />
    </>
  );
};

export default Header;
